import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'src/domains/common/components/alert/alert';
import Loading from 'src/components/Loading/Loading';
import { useAppStateContext } from 'src/AppState/AppState';
import { ActivityTimeframeState } from 'src/components/ComplianceConfiguration/ActivityTimeframe/ActivityTimeframe.state';
import { ActivityTimeframeForm } from 'src/components/ComplianceConfiguration/ActivityTimeframe/ActivityTimeframeForm';
import {
    ActivityTimeframeDescription,
    ActivityTimeframeWrapper,
} from 'src/components/ComplianceConfiguration/ActivityTimeframe/ActivityTimeframe.style';

export const ActivityTimeframe = observer((): JSX.Element => {
    const appState = useAppStateContext();
    const [state] = useState(() => new ActivityTimeframeState(appState));

    useEffect(() => () => state.dispose(), [state]);

    if (state.isLoading) {
        return (
            <ActivityTimeframeWrapper data-test='compliance-configuration-activity-timeframe-loading'>
                <Loading active />
            </ActivityTimeframeWrapper>
        );
    }

    return (
        <ActivityTimeframeWrapper data-test='compliance-configuration-activity-timeframe'>
            <Alert
                icon='info'
                title='Activity timeframe'
                variant='default'
            >
                Configure how often a user must perform an action (such as a click or movement) to be treated as active.
                If no action occurs within this window, inactivity counting begins.
            </Alert>

            <ActivityTimeframeDescription>
                Enter the activity window in minutes. Minimum 1 minute, maximum 60 minutes. Default is 1 minute.
            </ActivityTimeframeDescription>

            {state.errorMessage === null || state.errorMessage === '' ? null : (
                <Alert
                    icon='info'
                    title={state.errorMessage}
                    variant='destructive'
                />
            )}

            <ActivityTimeframeForm state={state} />
        </ActivityTimeframeWrapper>
    );
});
